define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/access/_base",
	"csi/access/crews",
	"csi/action",
	"csi/action/_StateMachineStateActions",
	"csi/config",
	"csi/def/Action",
	"csi/def/Request",
	"csi/reflection",
	"csi/xml"
], function(declare, lang, csi, access, crews, action, _StateMachineStateActions, config, Action, Request, reflection, xml) {

	return declare(Action, {
		// Boolean: indicates if action available only on latest revision
		_bLatestRevision: true,

		// Boolean: indicates if action available only during a running workflow
		_bRequiresWorkflow: false,

		// Boolean: indicates if action unavailable during a running workflow
		_bProhibitsWorkflow: true,

		// Number[]: ignore Frozen flag when checking access for state actions
		_nodeFlags: [xml.NODE_FLAG_NOEDIT],

		m_module: "SiteAdmin",

		constructor: function(obj) {
			// set default rights for action
			this.setBaseRights(xml.RIGHT_WRITE);

			// optimize action by not returning all modified nodes from publish
			this.setReturnParameters();
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: check for access based on current state and possibly roles
			const revision = ctx.getNode();
			const master = ctx.getNodeParent();

			if (!master ||
				!revision ||
				!this._hasStateAccess(ctx, master, revision) ||
				!xml.nodeHasAccess(master, xml.RIGHT_WRITE, reflection.ATTR_REVISIONS) ||
				this._isStateActionHidden(master) ||
				!this.inherited(arguments)
			) {
				return false;
			}

			if (this._bRequiresWorkflow || this._bProhibitsWorkflow) {
				const hasWorkflow = (revision.WorkflowExecution && revision.WorkflowExecution != csi.EMPTY_URL)
					? ctx.cache.getNode(revision.WorkflowExecution, true).FractionComplete < 1
					: false;
				if (this._bRequiresWorkflow && !hasWorkflow)
					return false;
				if (this._bProhibitsWorkflow && hasWorkflow)
					return false;
			}

			if (master.Offline && !this.isAvailableOffline(ctx)) {
				return false;
			}

			const roles = this._getStateRoles(ctx);
			return !roles || crews.isInRoles(roles, master);
		},

		isAvailableOffline: function(/*Context*/ctx) {
			return false;
		},

		isHidden: function(/*Context*/ctx) {
			// summary: return true if action has been hidden through configuration
			return this._isStateActionHidden(ctx.getNodeParent());
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: initialize post-processing and request if not already set
			this.m_postAction = this.m_postAction || "postActionRedrawNode";
			this.m_request = this.m_request || lang.mixin(new Request(), {m_module: this.m_module, m_operation: this.m_tag});
			this.inherited(arguments);
		},

		_getStateRoles: function(/*Context*/ctx) {
			// summary: return roles necessary to perform action (if any)
			return null;
		},

		_hasAssignedWorkflow: function(ctx, node) {
			return !!config.getNodeSetting(node, "WorkflowName") || !!config.getNodeClassSetting(node, "WorkflowName");
		},

		_hasStateAccess: function(/*Context*/ctx, /*Node*/master, /*Node*/revision) {
			// summary: check access based on current state
			var actions = _StateMachineStateActions[master.StateMachine];
			var stateActions = actions ? actions[revision.State] : null;
			return stateActions && stateActions[this.m_tag] && (!this._bLatestRevision || this._isLatestRevision(revision, master));
		},

		_isLatestRevision: function(/*Node*/revision, /*Node*/master) {
			return revision.$URL === master.LatestRevision;
		},

		_isStateActionHidden: function(/*Node*/master) {
			// summary: return true if action has been hidden through configuration for master node type
			return master && access.isResourceHidden(master.$Type, "", this.m_id);
		}
	});
});